.portfolioRotationWrapper {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  transform-origin: center center;
  position: absolute;
}

.board {
  position: absolute;
}

.cardsInCenter {
  position: relative;
  display: flex;
  flex-flow: row nowrap;

  & .cardsInDeckCount {
    position: absolute;
    bottom: -20px;
    text-align: center;
    width: 100%;
  }
}

.cardInCenterWrap {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px var(--ds-pearl-grey-darkest) dashed;
  border-radius: 4px;
}

.winnerBanner {
  position: absolute;

  text-align: center;

  background: var(--ds-highlight);
  border-radius: 12px;
  padding: 20px 12px;
  opacity: 0.95;

  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;

  & img {
    margin-right: 10px;
  }
}
